/**
 * List of the frequently used constants
 * @type {Object}
 */
const constant = {
	GET       : 'GET',
	POST      : 'POST',
	TYPE_JSON : 'json',
	keyCode   : {
		BACKSPACE       : 8,
		SHIFT           : 16,
		CTRL            : 17,
		ALT             : 18,
		CAPS            : 20,
		COMMA           : 188,
		DELETE          : 46,
		DOWN            : 40,
		END             : 35,
		ENTER           : 13,
		ESCAPE          : 27,
		HOME            : 36,
		LEFT            : 37,
		NUMPAD_ADD      : 107,
		NUMPAD_DECIMAL  : 110,
		NUMPAD_DIVIDE   : 111,
		NUMPAD_ENTER    : 108,
		NUMPAD_MULTIPLY : 106,
		NUMPAD_SUBTRACT : 109,
		PAGE_DOWN       : 34,
		PAGE_UP         : 33,
		PERIOD          : 190,
		RIGHT           : 39,
		SPACE           : 32,
		TAB             : 9,
		UP              : 38
	},
	event	: {
		KEY_UP   : 'keyup',
		KEY_DOWN : 'keydown',
		CLICK    : 'click'
	},
	entities : {
		'&'  : '&amp;',
		'<'  : '&lt;',
		'>'  : '&gt;',
		'"'  : '&quot;',
		'\'' : '&#39;',
		'/'  : '&#x2F;'
	},
	events : {
		CONFIRM_CONTROLLER : {
			WALL_POST_DELETED: 'wall-post-deleted'
		}
	}
};

export default constant;